import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class MultiFaGuard implements CanActivate, CanActivateChild {
  constructor(private _auth: AuthService, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkMultiFa();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return this.checkMultiFa();
  }

  private async checkMultiFa() {
    try {
      const authenticated = await this._auth.getAuthenticated();
      if (!authenticated) {
        this._router.navigate(['/multi-fa/options']);
        return false;
      }
      return true;
    } catch (error) {
      this._auth.signOut();
      this._router.navigate(['/sign-in']);
      return false;
    }
  }
}
